
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('Path')]),_c('desc',[_v('Created with Sketch.')]),_c('g',{attrs:{"id":"Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Attachments","transform":"translate(-84.000000, -329.000000)","fill":"#888888","fill-rule":"nonzero"}},[_c('g',{attrs:{"id":"attach_file-24px","transform":"translate(79.000000, 329.000000)"}},[_c('path',{attrs:{"d":"M13.75,5 L13.75,14.5833333 C13.75,16.425 12.2583333,17.9166667 10.4166667,17.9166667 C8.575,17.9166667 7.08333333,16.425 7.08333333,14.5833333 L7.08333333,4.16666667 C7.08333333,3.01666667 8.01666667,2.08333333 9.16666667,2.08333333 C10.3166667,2.08333333 11.25,3.01666667 11.25,4.16666667 L11.25,12.9166667 C11.25,13.375 10.875,13.75 10.4166667,13.75 C9.95833333,13.75 9.58333333,13.375 9.58333333,12.9166667 L9.58333333,5 L8.33333333,5 L8.33333333,12.9166667 C8.33333333,14.0666667 9.26666667,15 10.4166667,15 C11.5666667,15 12.5,14.0666667 12.5,12.9166667 L12.5,4.16666667 C12.5,2.325 11.0083333,0.833333333 9.16666667,0.833333333 C7.325,0.833333333 5.83333333,2.325 5.83333333,4.16666667 L5.83333333,14.5833333 C5.83333333,17.1166667 7.88333333,19.1666667 10.4166667,19.1666667 C12.95,19.1666667 15,17.1166667 15,14.5833333 L15,5 L13.75,5 Z","id":"Path"}})])])])])
          )
        }
      }
    